import React, { useState, useCallback, memo } from 'react';
import moment from 'moment';

const AdditionalInfoComponent = memo(({
  employeeCanEdit,
  additionalInfoData,
  onEditClick,
}) => { 
  const [isOpen, setIsOpen] = useState(true);
  const toggleAccordion = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  const handleEditClick = useCallback((e) => {
    e.stopPropagation(); 
    onEditClick();
  }, [onEditClick]);


  return (
    <div className="col-md-12 mt-2 p-0">
      <div className="empProfile-accordion">
        <div className="OfficialInfo-header" onClick={toggleAccordion}>
          <h6 className="mb-0 d-flex align-items-center gap-1">
            My Additional Information
            <i
              style={{
                fontSize: "12px",
                cursor: "pointer",
                cursor: "not-allowed",
                opacity: 0.5,
              }}
              className="bi bi-pencil-square"
              // onClick={handleEditClick}
            ></i>
          </h6>
          <span className={`arrow-icon ${isOpen ? "open" : ""}`}>
            <i className="bi bi-arrow-down-circle-fill icon-acc"></i>
          </span>
        </div>
        {isOpen && (
          <div className="OfficialInfo-body">
            <div className="d-flex flex-column gap-2">
              <table className="table table-bordered table-hover">
                <tbody className="info-compact-table">
                  <tr>
                    <th className="bg-light">Passport No.</th>
                    <td>{additionalInfoData?.PassportNo || ""}</td>
                  </tr>
                  <tr>
                    <th className="bg-light">Passport DOI</th>
                    <td>
                      {additionalInfoData?.PassportEffectiveDate
                        ? moment(additionalInfoData.PassportEffectiveDate).format("DD-MMM-YYYY")
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <th className="bg-light">Passport DOE</th>
                    <td>
                      {additionalInfoData?.PassportExpiryDate
                        ? moment(additionalInfoData.PassportExpiryDate).format("DD-MMM-YYYY")
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <th className="bg-light">PAN No.</th>
                    <td>{additionalInfoData?.PANNo || ""}</td>
                  </tr>
                  <tr>
                    <th className="bg-light">License No.</th>
                    <td>{additionalInfoData?.LicenseNo || ""}</td>
                  </tr>
                  <tr>
                    <th className="bg-light">Aadhaar No.</th>
                    <td>{additionalInfoData?.AadhaarCardNo || ""}</td>
                  </tr>
                  <tr>
                    <th className="bg-light">PF No.</th>
                    <td>{additionalInfoData?.PFNo || ""}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default AdditionalInfoComponent;